import api from "../../action/api";

const apiUrl = process.env.REACT_APP_ADMIN_API;
const apiUrlRMS = process.env.REACT_APP_RMS_API;
const apiUrladmin = process.env.REACT_APP_ADMINCENTER_API;
const tenantId = localStorage.getItem("realmNameTAC");

const API = {
  GET_COUNTRIES: `${apiUrlRMS}Master/Countries`,

  GoogleUpload: `${apiUrl}/Application/GoogleCredentials/Upload`,
  GoogleDownload: `${apiUrl}/Application/GoogleCredentials/Download`,
  GoogleDelete: `${apiUrl}/Application/GoogleCredentials/Delete`,
  MicrosoftMeetings: `${apiUrl}/Application/MicrosoftCredentials`,
  GetGoogleUsers:`${apiUrl}/api/Google/GoogleUsers`,
  GetMicrosoftUsers:`${apiUrl}/api/Azure/AzureUsers`,
  GoogleAdmin:`${apiUrl}/api/Google/GoogleAdmin/Credentials`,
  GetProductsList:`${apiUrl}/Application/myapplications`,
  GetTenantAdminId:`${apiUrl}/Application/tenantAdminAppId`,

  //Invoices
  GET_INVOICE_DETAILS: `${apiUrl}/invoice/all`,
  GET_PARTICULAR_INVOICE: `${apiUrl}/invoice/`,
  DOWNLOAD_PDF: `${apiUrl}/Invoice/download`,

  //Users
  GET_USERS_LIST: `${apiUrl}/User/List`,
  GET_USERS_LIST_WOPAGE: `${apiUrl}/User/List/withoutpagination`,
  GET_USER: `${apiUrl}/User/`,
  POST_USER: `${apiUrl}/User/${tenantId}/Create`,
  PUT_USER: `${apiUrl}/User/${tenantId}/Update`,
  DELETE_USER: `${apiUrl}/User`,
  EMAIL_VERIFY: `${apiUrl}/User`,
  GET_LOGOUT: `${apiUrl}/User/LogoutRedirectURL`,
  LAST_LOGIN: `${apiUrl}/User/LastLogin`,
  VERIFY_INVITE: `${apiUrl}/User/VerifyInviteLink`,
  RESET_API: `${apiUrl}/User/Reset`,
  CHANGE_PASSWORD: `${apiUrl}/User/ChangePassword`,

  //Applications
  GET_APPLICATION_LIST: `${apiUrl}/Tenant/Application/List`,
  GET_LICENSE_VIEW_FORM: `${apiUrl}/Tenant/Application/License/`,
  GET_APPLICATION_USERS_LIST: `${apiUrl}/Tenant/Application/Users`,
  PUT_LICENSE: `${apiUrl}/Tenant/Application/PurchaseLicenses`,
  POST_ROLE_USER: `${apiUrl}/Tenant/Application/MapUsers`,
  DELETE_ROLE_USER: `${apiUrl}/Tenant/Application/Role/Users`,
  IsSSO: `${apiUrl}/Tenant/IsSSOConfigured`,

  //new things
  GET_ALL_APPLICATION_DETAILS: `${apiUrl}/Application/all`,
  GET_ALL_SUBSCRIPTION_DETAILS: `${apiUrl}/Application/all/subscribed`,
  GET_APPLICATION: `${apiUrl}/application`,
  GET_UNASSIGNED_USERS: `${apiUrl}/application`,
  GET_ROLE_BASED_USERS: `${apiUrl}/application`,
  VALIDATION_CHECK: `${apiUrl}/application`,
  PURCHASE_LICENSE: `${apiUrl}/application`,
  USER_ROLE_ASSIGN: `${apiUrl}/application`,
  USER_ROLE_REMOVE: `${apiUrl}/application`,
  ADIT_LOG: `${apiUrl}/application`,
  UNSUBSCRIBE: `${apiUrl}/application/unsubscribe`,
  SUBSCRIBE: `${apiUrl}/application/subscribe`,
  TRAIL: `${apiUrl}/application/trial`,
  DELETETRAIL: `${apiUrl}/Application/trial`,
  GET_PRODUCTS_DETAILS: `${apiUrl}/application/plan/`,
  TRY_OR_BUY_PRODUCTS: `${apiUrl}/application/details/`,

  //GROUPS
  ALL_GROUPS: `${apiUrl}/Group/all`,
  ASSIGNED_MEMBERS: `${apiUrl}/Group`,
  NEW_GROUP: `${apiUrl}/Group`,
  ADD_MEMBER_GROUP: `${apiUrl}/Group`,
  DELETE_MEMBER_GROUP: `${apiUrl}/Group`,
  DELETE_GROUP: `${apiUrl}/Group`,
  EDIT_GROUP: `${apiUrl}/Group`,

  //Settings
  GET_SSO_DETAILS: `${apiUrl}/Tenant/IdentityProviders`,
  POST_SSO_DETAILS: `${apiUrl}/Tenant/ConfigureIdentityProvider`,
  PUT_SSO_DETAILS: `${apiUrl}/Tenant/ConfigureIdentityProvider`,
  DELETE_SSO_DETAILS: `${apiUrl}/Tenant/IdentityProvider/`,
  LOGOUT_SESSIONS: `${apiUrl}/Tenant/LogoutAllUsers`,
  GET_GLOBAL_SETTINGS: `${apiUrl}/Tenant/globalsettings`,
  UploadLogo: `${apiUrl}/Tenant/TenantLogo`,
  GET_LANGUAGE: `${apiUrl}/Master/Language`,
  GLOBAL_SETTINGS_API_UPDATE: `${apiUrl}/Tenant/GlobalSettings`,
  GET_COUNTRY: `${apiUrl}/Master/Country`,
  GET_TimeZone: `${apiUrl}/Master/TimeZone`,
  GET_DATEFormat: `${apiUrl}/Master/Dateformat`,

  //Create Account
  CREATE_ACCOUNT: `${apiUrl}/User/Register`,
  VERIFY_EMAIL: `${apiUrl}/User/Verify`,
  RESEND_OTP: `${apiUrl}/User/Resend`,
  CREATE_ACCOUNT_REGISTER_KEYCLOAK: `${apiUrl}/User/RegisterKeycloak`,
  CREATE_ACCOUNT_REGISTER_KEYCLOAKMOCK: `${apiUrl}/User/RegisterKeycloakMock`,

  // Teams
  Teams: `${apiUrl}/Teams`,

  TrialCount: `${apiUrl}/Master/value/TrialCount`,
  cancellationReason: `${apiUrl}/Master/values/ReasonForCancellation`,
  getNotes: `${apiUrl}/Master/Notes`,
};

export default API;
